<template>
  <div v-if="company.permissions.includes('excise.file')">
    <v-tooltip v-if="month>excisePeriodEnd" bottom max-width="300">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" color="primary" small @click="exciseFile=true">Mark as filed</v-btn>
      </template>
      It is good practice to mark your excise returns as filed in order to prevent transactions
      affecting excise in a filed period.
    </v-tooltip>
    <span v-else style="cursor:pointer" @click="exciseUnfile=true">
      Excise filed to end of {{company.excisePeriodEnd | formatDate}}
    </span>

    <reports-excise-file v-model="exciseFile"/>
    <reports-excise-unfile v-model="exciseUnfile"/>
  </div>
</template>

<script>
import ReportsExciseFile from '@/views/reports/excise/ReportsExciseFile';
import ReportsExciseUnfile from '@/views/reports/excise/ReportsExciseUnfile';

export default {
  name: 'ReportsExciseFileButton',
  components: {ReportsExciseFile,ReportsExciseUnfile},
  props: {
    month: {type:String, required:true}
  },
  data() {
    return {
      exciseFile: false,
      exciseUnfile: false
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    excisePeriodEnd() {
      return this.company.excisePeriodEnd.substring(0,7);
    }
  }
}
</script>